import RouteMap from "../RouteMap/RouteMap";
import { KITCHEN_ROUTES } from "../../routes/ROUTES";

export default function Kitchen() {
  return (
    <div className="container">
      <RouteMap items={KITCHEN_ROUTES} />
    </div>
  );
}
